export const CANDIDATE_STATUS = [
    { label: 'Applied', value: 'applied', key: 'applied', color: 'blue', tooltip: 'Candidate has applied to the job' },
    { label: 'Phone Screen', value: 'phoneScreen', key: 'phoneScreen', color: 'cyan', tooltip: 'Initial screening call scheduled' },
    { label: 'Profile Completed', value: 'profileCompleted', key: 'profileCompleted', color: 'green', tooltip: 'Candidate profile is fully filled' },
    { label: 'Technical Round', value: 'technicalRound', key: 'technicalRound', color: 'orange', tooltip: 'Technical interview round scheduled or completed' },
    { label: 'Assessment', value: 'assessment', key: 'assessment', color: 'purple', tooltip: 'Candidate is taking or has completed the assessment test' },
    { label: 'Accepted', value: 'accepted', key: 'accepted', color: 'success', tooltip: 'Candidate has been accepted' },
    { label: 'Rejected', value: 'rejected', key: 'rejected', color: 'volcano', tooltip: 'Candidate has been rejected' },
    {
        label: 'Convert To User',
        value: 'convertToUser',
        key: 'convertToUser',
        color: 'geekblue',
        tooltip: 'Candidate has been converted into a registered platform user'
    },


]